var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _vm.editor
        ? [
            _c("ckeditor", {
              attrs: { editor: _vm.editor, config: _vm.editorConfig },
              on: { input: _vm.change },
              model: {
                value: _vm.ckValue,
                callback: function ($$v) {
                  _vm.ckValue = $$v
                },
                expression: "ckValue",
              },
            }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }